module.exports = __webpack_public_path__ + "img/chat-alt-2.11c6519.png";